import React from 'react'
import { useQuery } from '@apollo/react-hooks'
import { useParams } from 'react-router-dom'
import { examsPropertiesQueries } from '../../graphql/queries'
import AtividadeProva from './AtividadeProva'
import { array } from '../../utils'

const ExamInfo = () => {
    const { id } = useParams()

    const { loading, error, data } = useQuery(examsPropertiesQueries.GET_CUSTOM_EXAM, {
        variables: {
            _id: id
        }
    })

    if (error || loading ) return null

    const {provaPersonalizada} = data

    if (!provaPersonalizada) return null

    if(provaPersonalizada.perguntasAleatorias) {
        provaPersonalizada.perguntas = array.shuffle(provaPersonalizada.perguntas)
    }

    if(provaPersonalizada.respostasAleatorias) {
        provaPersonalizada.perguntas.map(item => {
            item.respostas = array.shuffle(item.respostas)
            return item
        }) 
    }

    return <AtividadeProva data={(data || {}).provaPersonalizada} type="Prova Personalizada" id={id}/>
}

export default ExamInfo